export default __webpack_public_path__ + "static/media/search.0155d6ce.svg";